var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04999 2.09999H10.95C11.5249 2.09999 12 1.6249 12 1.04999C12 0.475078 11.5249 0 10.95 0H1.04999C0.475078 0 0 0.475088 0 1.04999C0 1.62491 0.474894 2.09999 1.04999 2.09999Z",
    fill: "#2B190C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.95 6.09961H1.04999C0.475078 6.09961 0 6.5747 0 7.1496C0 7.72451 0.475088 8.1996 1.04999 8.1996H14.95C15.5249 8.1996 16 7.72451 16 7.1496C16 6.57449 15.5249 6.09961 14.95 6.09961Z",
    fill: "#2B190C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 12.1992H1.04999C0.475078 12.1992 0 12.6743 0 13.2492C0 13.8241 0.475088 14.2992 1.04999 14.2992H10.95C11.5249 14.2992 12 13.8241 12 13.2492C12 12.6741 11.5249 12.1992 10.95 12.1992Z",
    fill: "#2B190C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManue);
export default __webpack_public_path__ + "static/media/manue.8bdf4d9757a962587190380d3664ae9e.svg";
export { ForwardRef as ReactComponent };